import { createContext, type Dispatch } from 'react';
import type { ChatState } from './interfaces';

type ChatStateDispatch = Dispatch<ChatState.Action>;

export const ChatStateDispatchContext = createContext<ChatStateDispatch>(null);